import { useContext } from 'react'
import { useMutation as useMutationOriginal } from '@apollo/client'
import { transformData } from '../utils'
import { StatusIndicatorContext } from '../context/StatusIndicatorContext'
import gql from 'graphql-tag'

const useMutation = (mutation, options = {}) => {
	const noMutation = !mutation
	const { onCompleted, withIndicator = true, ...restOptions } = options
	const { addPromise } = useContext(StatusIndicatorContext)

	const handleOnCompleted = data => {
		if(typeof onCompleted === 'function') {
			const { data: transformedData, ...dataInfo } = transformData(data)
			onCompleted(transformedData, dataInfo)
		}
	}

	/*
		by design react hooks are not skipable but we can skip react-apollo's `useMutation`
		by providing some placeholder gql and returning nothing in upper hook
	*/
	const [mutate, { data, ...restMutation }] = useMutationOriginal(noMutation ? gql`mutation{_}` : mutation, {
		...restOptions,
		onCompleted: handleOnCompleted
	})

	const handleMutate = (mutateOptions = {}) => {
		const { update, onError, ...rest } = mutateOptions
		let parameters = rest
		if(typeof update === 'function') {
			parameters.update = (cache, { data: updateData, ...restUpdateCache }) => {
				const { data: transformedData } = transformData(updateData)
				return update(cache, {
					...restUpdateCache,
					data: transformedData
				})
			}
		}
		const promise = mutate(parameters)
		if(withIndicator) {
			addPromise(promise)
		}
		return promise
	}

	const { data: transformedData, ...dataInfo } = transformData(data)

	return noMutation ? [] : [handleMutate, {
		...restMutation,
		...dataInfo,
		data: transformedData
	}]
}

export default useMutation
